module.exports = __webpack_public_path__ + "img/Speaker=Robyn Orsini.a8d07b7f.png";